const commonStyles = {
  padding: '8px',
  fontSize: '1rem',
  fontWeight: '500',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  borderRadius: '8px',
  maxHeight: '36px',
};

export default {
  button: {
    ...commonStyles,
    color: '#fff',
    backgroundColor: (theme) => theme.palette.blues.primaryBlue,
    '&:hover': {
      backgroundColor: (theme) => theme.palette.blues.primaryBlue600,
    },
    '&:focus': {
      backgroundColor: (theme) => theme.palette.blues.primaryBlue700,
    },
    '&:disabled': {
      color: (theme) => theme.palette.blues.primaryBlue400,
      backgroundColor: (theme) => theme.palette.blues.primaryBlue100,
    },
  },
  outlinedButton: {
    ...commonStyles,
    color: (theme) => theme.palette.blues.primaryBlue500,

    backgroundColor: '#fff',
    border: (theme) => `1px solid ${theme.palette.blues.primaryBlue}`,
    '&:hover': {
      backgroundColor: '#fff',
      color: (theme) => theme.palette.blues.primaryBlue700,
      border: (theme) => `1px solid ${theme.palette.blues.primaryBlue700}`,
    },
    '&:focus': {
      backgroundColor: '#fff',
      color: (theme) => theme.palette.blues.primaryBlue700,
      border: (theme) => `1px solid ${theme.palette.blues.primaryBlue700}`,
    },
    '&:disabled': {
      color: (theme) => theme.palette.blues.primaryBlue400,
      backgroundColor: '#fff',
      border: (theme) => `1px solid ${theme.palette.blues.primaryBlue400}`,
    },
  },
};
